module.exports = __webpack_public_path__ + "img/576-42dfb3.png";